import { render, staticRenderFns } from "./UserSchoolMethodGroups.vue?vue&type=template&id=19bbae38&scoped=true&"
import script from "./UserSchoolMethodGroups.vue?vue&type=script&lang=js&"
export * from "./UserSchoolMethodGroups.vue?vue&type=script&lang=js&"
import style0 from "./UserSchoolMethodGroups.vue?vue&type=style&index=0&id=19bbae38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bbae38",
  null
  
)

export default component.exports